class PrivateLabelCustomizer {
  constructor(section) {
    this.section = section;
    this.input = section.querySelector('[data-private-label-upload]');
    this.status = section.querySelector('[data-private-label-status]');
    this.previews = section.querySelectorAll('[data-private-label-preview]');
    this.objectUrl = null;

    if (!this.input || !this.status || !this.previews.length) return;

    section.querySelectorAll('[data-private-label-upload-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.input.click());
    });
    this.input.addEventListener('change', () => this.handleFile());
  }

  setStatus(message) {
    this.status.textContent = message;
  }

  clearPreview() {
    this.previews.forEach((preview) => {
      preview.removeAttribute('src');
      preview.alt = '';
      preview.hidden = true;
    });
  }

  handleFile() {
    const file = this.input.files && this.input.files[0];
    if (!file) return;

    const validMimeTypes = ['image/jpeg', 'image/png'];
    const validExtension = /\.(jpe?g|png)$/i.test(file.name);
    const isSupported = validMimeTypes.includes(file.type) || (!file.type && validExtension);

    if (!isSupported) {
      this.input.value = '';
      this.clearPreview();
      this.setStatus('Choose a PNG or JPEG image to preview your logo.');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      this.input.value = '';
      this.clearPreview();
      this.setStatus('Choose an image smaller than 5 MB to preview your logo.');
      return;
    }

    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
    this.objectUrl = URL.createObjectURL(file);
    this.previews.forEach((preview) => {
      preview.src = this.objectUrl;
      preview.alt = `Preview of ${file.name}`;
      preview.hidden = false;
    });
    this.setStatus(`${file.name} is shown as a preview only and is not uploaded or saved.`);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-private-label-customizer]').forEach((section) => new PrivateLabelCustomizer(section));
});
